import { Icons } from "@components/index";
import styles from "./CollapseButton.module.scss";

type Direction = "up" | "down" | "left" | "right";

const ROTATION_MAP: Record<Direction, string> = {
  up: styles["rotate-up"],
  right: styles["rotate-right"],
  down: styles["rotate-down"],
  left: styles["rotate-left"],
};

const ROTATION_INVERTED: Record<Direction, string> = {
  up: styles["rotate-down"],
  right: styles["rotate-left"],
  down: styles["rotate-up"],
  left: styles["rotate-right"],
};

interface CollapseButtonProps {
  isCollapsed: boolean;
  onClick: () => void;
  direction?: Direction;
  className?: string;
}

const CollapseButton: React.FC<CollapseButtonProps> = ({
  isCollapsed,
  onClick,
  direction = "up",
  className,
}) => {
  const rotationClass = isCollapsed
    ? ROTATION_INVERTED[direction]
    : ROTATION_MAP[direction];
  const buttonClass = className
    ? `${styles.button} ${className}`
    : styles.button;

  return (
    <button type="button" className={buttonClass} onClick={onClick}>
      <Icons icon="chevron-double-up" size="sm" className={rotationClass} />
    </button>
  );
};

export default CollapseButton;
